
// react-bootstrap imports
import { useState } from "react"
import { Button, Form } from "react-bootstrap"

// components imports
import { DropdownInput, TextInput } from "components/Inputs"
import { ErrorChamadaApiMessage, SuccessDataSaved, WarningIncompleteInput, WarningInvalidInput } from "components/AlertMessages"

import { updateUserData, userHasAccess, userLogado } from "services/LoginFunctions"
import { AddPermissao, RemoverPermissao } from "services/CallAPIs"
import { getFormData } from "services/FormFunctions"

import * as Links from "constants/links"
import { useNavigate } from "react-router-dom"

import stdStyle from "json/StdStyles.json"
import { ROLE } from "constants/userRoles"

export const GerenciarPermissoesScreen = () =>
{
    const itemsList = [ROLE.ANALISTA, ROLE.TESTER, ROLE.GESTOR]
    const [showSucesso, setShowSucesso] = useState(false)
    const [showAlertIncompleteInput, setShowAlertIncompleteInput] = useState(false)
    const [showAlertDadosIncorretos, setShowAlertDadosIncorretos] = useState(false)
    const [showErrorChamarApi, setShowErrorChamarApi] = useState(false)
    let add = false
    const navigate = useNavigate()

    if (!userLogado || !(userHasAccess(ROLE.GESTOR) || userHasAccess(ROLE.ADMIN)))
    {
        navigate(Links.SEM_PERMISSAO)
    }


    const submitForm = async event =>
    {
        event.preventDefault()
        const form = event.currentTarget
        const formData = getFormData(form)
        
        if (!form.checkValidity())
        {
            setShowAlertIncompleteInput(true)
            return
        }
        if (!userLogado) { return }
        if (formData.senha !== formData.senhaConfirmar) { return }

        try
        {
            const data = 
            {
                roleName: formData.roleName,
                matricula: formData.matricula
            }
            await add ? AddPermissao(data, setShowErrorChamarApi) :  RemoverPermissao(data, setShowErrorChamarApi)
            
            setShowSucesso(true)
        }
        catch (error)
        {
            alert("Erro ao tentar adicionar ou remover permissão")
            setShowAlertDadosIncorretos(true)
        }
    }

    return (

        <>
            <SuccessDataSaved show={showSucesso} setShow={setShowSucesso} />
            <WarningInvalidInput show={showAlertDadosIncorretos} setShow={setShowAlertDadosIncorretos} messages={["Matrícula não encontrada ou permissão não selecionada"]} />
            <WarningIncompleteInput show={showAlertIncompleteInput} setShow={setShowAlertIncompleteInput} />
            <ErrorChamadaApiMessage apiName={"Login"} show={showErrorChamarApi} setShow={setShowErrorChamarApi} />

            <Form className={stdStyle.form} noValidate onSubmit={submitForm}>
                
                <DropdownInput Name={"roleName"} Value={"Tipo"} Label={"Permissão"} ItemsList={itemsList} Req={true} />
                <TextInput Name={"matricula"} Placeholder={"000000"} Label={"Matrícula"} Req={true} MinWidth={0} />
                <div className="d-flex flex-column">
                    <Button className="mt-3" type="submit" onClick={() => {add = true}}>Adicionar permissão</Button>
                    <Button className="mt-3" type="submit" variant="danger" onClick={() => {add = false}}>Remover permissão</Button>
                </div>

            </Form>
        </>

    )
}